import {
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'app-taiga-chapter-dropzone',
  templateUrl: './taiga-chapter-dropzone.component.html',
  styleUrls: ['./taiga-chapter-dropzone.component.css'],
})
export class TaigaChapterDropzoneComponent
{
  @Input() loading = false;
  @Output() filesDropped = new EventEmitter<File[]>();
  @Output() filesRejected = new EventEmitter<void>();
  isDragged = false;

  readonly accept =
    '.pdf,.jpg,.jpeg,.png,.gif,.mp4,.mov,application/pdf,image/*,video/mp4,video/quicktime';

  onReject(): void {
    this.filesRejected.emit();
  }

  onInputChange(event: Event): void {
    if (this.loading) {
      return;
    }

    const target = event.target as HTMLInputElement | null;
    const files = target?.files ? Array.from(target.files) : [];

    this.processFiles(files);
    if (target) {
      target.value = '';
    }
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    if (this.loading) {
      return;
    }
    this.isDragged = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    this.isDragged = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    this.isDragged = false;

    if (this.loading) {
      return;
    }

    const files = event.dataTransfer?.files
      ? Array.from(event.dataTransfer.files)
      : [];
    this.processFiles(files);
  }

  private processFiles(files: File[]): void {
    if (!files.length) {
      return;
    }

    const invalidFile = files.find((file) => !this.isAccepted(file));
    if (invalidFile) {
      this.onReject();
      return;
    }

    this.filesDropped.emit(files);
  }

  private isAccepted(file: File): boolean {
    const tokens = this.accept
      .split(',')
      .map((token) => token.trim().toLowerCase())
      .filter(Boolean);
    const fileName = (file.name || '').toLowerCase();
    const fileType = (file.type || '').toLowerCase();

    return tokens.some((token) => {
      if (token.endsWith('/*')) {
        const baseType = token.replace('/*', '/');
        return fileType.startsWith(baseType);
      }
      if (token.startsWith('.')) {
        return fileName.endsWith(token);
      }
      return token === fileType;
    });
  }
}
